import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/helpers/classNames"

const badgeVariants = cva(
  `
    inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs
    font-semibold transition-colors
    focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden
  `,
  {
    variants: {
      variant: {
        default: `
          border-transparent bg-primary-300 text-neutral-100
          hover:bg-primary-200
        `,
        secondary: `
          border-transparent bg-secondary text-secondary-foreground
          hover:bg-secondary/80
        `,
        destructive: `
          border-transparent bg-danger-300 text-neutral-100
          hover:bg-danger-300/80
        `,
        outline: "text-foreground",
        // these 4 variants are specific to our app
        danger: "border-transparent bg-danger-100",
        inactive: "border-transparent bg-neutral-300",
        success: "border-transparent bg-success-100",
        warning: "border-transparent bg-warning-100",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge }
